module.exports = __webpack_public_path__ + "img/doc-white.21fb7720.png";